import { formatDateTimeString } from '@sbv-clients/util-misc';

export const getGreetingAndLabel = () => {
  const now = new Date();
  const hour = now.getHours();
  return {
    greeting:
      hour < 12
        ? 'Good morning'
        : hour < 18
        ? 'Good afternoon'
        : 'Good evening',
    todayLabel: formatDateTimeString(now, 'EEEE, MMMM d'),
  };
};

export const sumMinutesToHours = (
  rows: {
    totalMinutesCurrent?: number;
    totalMinutesPrevious?: number;
    otMinutesCurrent?: number;
    otMinutesPrevious?: number;
  }[],
  field:
    | 'totalMinutesCurrent'
    | 'totalMinutesPrevious'
    | 'otMinutesCurrent'
    | 'otMinutesPrevious'
) =>
  Math.round((rows.reduce((acc, r) => acc + (r[field] ?? 0), 0) / 60) * 10) /
  10;

export const calcPct = (curr: number, prev: number) =>
  prev === 0 ? 0 : Math.round(Math.abs(((curr - prev) / prev) * 100) * 10) / 10;
